export default __webpack_public_path__ + "static/lewis-ab276d6316df657c9fd49648da458b0e.jpg";